<template>
  <!-- 商品滚播(组件) -->
  <div class="block" style="background: white; margin-top: 15px">
    <div class="roll-div">
      <div class="product-menu">
        <div
          @click="getListSale"
          class="menu-item"
          :class="{ selected: choosed === '0' }"
        >
          <img v-if="choosed === '0'" class="select-image" :src="select" />
          热卖推荐
        </div>
        <div
          @click="getListNew"
          class="menu-item"
          :class="{ selectedBlue: choosed === '1' }"
        >
          <img v-if="choosed === '1'" class="select-image" :src="selectBlue" />
          新品速递
        </div>
      </div>
    </div>
    <el-carousel
      trigger="click"
      height="696px"
      :interval="intervalue"
      arrow="never"
    >
      <el-carousel-item v-for="item in goodsData">
        <template v-for="record in item">
          <div
            @mouseover="handleMouseOver(record)"
            @mouseout="handleMouseOut(record)"
            @click="handleJumpProduct(record)"
            class="roll-body"
          >
            <div
              style="
                float: left;
                width: 90px;
                height: 90px;
                margin: 0 0 0 8px;
                box-sizing: border-box;
              "
            >
              <img
                slot="reference"
                style="width: 100%; height: 100%"
                :src="`${record.picUrl}?x-oss-process=image/resize,m_fill,h_200,w_200`"
              />
            </div>

            <div class="roll-title">
              <p :title="record.proName">{{ record.proName }}</p>
              <p style="margin-top: 4px; color: #333333">
                ¥<span class="roll-price" style="color: #333333">{{
                  record.skuList[0].sellPrice
                }}</span>
              </p>
            </div>
          </div>
        </template>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import hot from "@/assets/images/index/hot.png"
import newImage from "@/assets/images/index/new.png"
import select from "@/assets/images/user/select.png"
import selectBlue from "@/assets/images/user/select-blue.png"
import { listNew, listSale } from "@/api/customProduct/product"

export default {
  name: "Broadcast",
  components: {},
  data() {
    return {
      goodsData: [],
      hotGoods: [],
      newGoods: [],
      elHot: { background: "red" },
      elNew: { background: "rgb(255,255,255,0)" },
      intervalue: 7000,
      hot: hot,
      newImage: newImage,
      choosed: "0",
      select: select,
      selectBlue: selectBlue,
      params: {
        pageNum: "1",
        pageSize: "5",
      },
    }
  },
  created() {
    // this.hotArticle()
    this.getListSale()
    this.choosed = "0"
  },
  methods: {
    /**/
    hotArticle() {},
    /**/
    newArticle() {},
    async getListNew() {
      this.elNew.background = "red"
      this.elNew.color = "white"
      this.elHot.background = ""
      this.elHot.color = ""
      this.choosed = "1"
      let result = await listNew({ pageNum: 1, pageSize: 12 })
      let newGoods = []
      let array = []
      for (let record of result.rows) {
        array.push(record)
        for (let image of record.mainList) {
          if (image.isMain == "2") {
            record.picUrlHover = image.picUrl
          }
          if (image.isMain == "1" && !record.picUrlBak) {
            record.picUrl = image.picUrl
            record.picUrlBak = image.picUrl
          }
        }

        if (array.length == 6) {
          newGoods.push(this._.clone(array))
          array = []
        }
      }
      if (array.length > 0) {
        newGoods.push(array)
      }
      this.goodsData = newGoods
    },
    async getListSale() {
      this.elHot.background = "red"
      this.elHot.color = "white"
      this.elNew.background = ""
      this.elNew.color = ""
      this.choosed = "0"
      let result = await listSale({ pageNum: 1, pageSize: 12 })
      let array = []
      let goods = []
      for (let record of result.rows) {
        array.push(record)
        for (let image of record.mainList) {
          if (image.isMain == "2") {
            record.picUrlHover = image.picUrl
          }
          if (image.isMain == "1" && !record.picUrlBak) {
            record.picUrl = image.picUrl
            record.picUrlBak = image.picUrl
          }
        }

        if (array.length == 6) {
          goods.push(this._.clone(array))
          array = []
        }
      }
      if (array.length > 0) {
        goods.push(array)
      }
      this.goodsData = goods
    },
    handleMouseOver(record) {
      if (record.picUrlHover) {
        record.picUrl = record.picUrlHover
      }
    },
    handleMouseOut(record) {
      record.picUrl = record.picUrlBak
    },
    handleJumpProduct(row) {
      let routeUrl = this.$router.resolve({
        path: "/select/custom/product",
        query: { pId: row.pId },
      })
      window.open(routeUrl.href, "_blank")
    },
  },
}
</script>

<style lang="scss" scoped>
.block {
  background: white;
  border: 1px solid #cccccc;
  margin-top: 15px;
  box-sizing: border-box;
}
.block .roll-btn {
  width: 50%;
  height: 100%;
  float: left;
}
.block .roll-leftBtn:hover,
.block .roll-rightBtn:hover {
  background: red;
}
.block .roll-div {
  height: 45 px;
  text-align: center;
  line-height: 15px;
  font-size: 15px;
  cursor: pointer;
}

.block ::v-deep .el-carousel__button {
  width: 7px;
  height: 7px;
  border-radius: 8px;
}
.block ::v-deep .el-carousel__button {
  background: #8f8f90;
}
.block ::v-deep .el-carousel__indicator.is-active button {
  background: #409eff;
}

.block .roll-body {
  width: 100%;
  padding: 10px 0;
  border-bottom: 1px solid #d6d2cf;
  overflow: hidden;
}
.block .roll-body:hover {
  background: #ecf5ff;
  cursor: pointer;
}
.block .roll-title {
  width: 44%;
  float: left;
  font-size: 13px;
  padding: 0 0 0 8px;
}
.block .roll-title p {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.block .roll-title span {
  color: #409eff;
  font-size: 16px;
  font-weight: bold;
}
.product-menu {
  background: #ffffff;
  overflow: hidden;
  text-align: center;
  height: 45px;
  .menu-item {
    float: left;
    font-size: 14px;
    line-height: 45px;
    width: 30%;
    position: relative;
    padding: 0 21px 0 21px;
    height: 45px;
    background: #ebeced;
    .img1 {
      position: absolute;
      right: -8px;
      height: 16px;
      top: 3px;
    }
    .img2 {
      position: absolute;
      right: -24px;
      height: 12px;
      top: 6px;
    }
  }
  .selected {
    color: #ff8f21;
    font-weight: bold;
    background: #ffffff;
  }
  .selectedBlue {
    color: #1d7ef2;
    font-weight: bold;
    background: #ffffff;
  }
  .select-image {
    position: absolute;
    width: 106px;
    top: 0px;
    left: 0;
  }
}
</style>
